import DataTable from "@/components/application/data-table";
import SuperadminLayout from "@/components/superadmin/layout";
import useTranslations from "@/hooks/use-translations";
import { formatDate } from "@/lib/utils";
import { SuperadminStore } from "@/types";
import { ColumnDef } from "@tanstack/react-table";
import { ReactNode } from "react";

function useColumns(): ColumnDef<SuperadminStore>[] {
  const { t } = useTranslations("superadmin.stores.index");

  return [
    {
      accessorKey: "name",
      header: t("table.name"),
    },
    {
      accessorKey: "subdomain",
      header: t("table.subdomain"),
    },
    {
      accessorKey: "owner_email",
      header: t("table.owner_email"),
    },
    {
      accessorKey: "products_count",
      header: t("table.products_count"),
    },
    {
      accessorKey: "collections_count",
      header: t("table.collections_count"),
    },
    {
      accessorKey: "created_at",
      header: t("table.created_at"),
      cell: ({ row }) => formatDate(row.original.created_at),
    },
  ];
}

function StoresPage({ stores }: { stores: SuperadminStore[] }) {
  const { t } = useTranslations("superadmin.stores.index");
  const columns = useColumns();

  return (
    <div className="flex flex-col gap-6">
      <h2 className="font-semibold text-2xl">{t("title")}</h2>

      <DataTable<SuperadminStore> columns={columns} data={stores} />
    </div>
  );
}

StoresPage.layout = (page: ReactNode) => <SuperadminLayout children={page} />;

export default StoresPage;
